import {objToArrK, pickKeys} from '../tools/CommonJS';
import {dispDateTime} from '../tools/CommonHtml';
import {HA_genRemedies, HA_Remedies, HA_topics, misconTopicFlags} from './MisconData';
import {Benchmark_cisProfilesById, Benchmark_rules, Comp_remedies, xBenchmark_Repo} from './BenchmarkData';
import {benchmarkLevelOpts, BenchmarkOrg, notUsedInDaysOpts} from './CommonUIData';
import {validatePatchModuleLicense} from './ModuleLicense';

export function xTopic_Repo(topicCode) {
	if (!topicCode) return '';
	const topic = HA_topics[topicCode] || xBenchmark_Repo({topicCode});

	return {
		title: topic.unrecognized ? topicCode : topic.title,
		severity: topic.severity,
		paramTitle: topic.paramTitle,
		unrecognized: topic.unrecognized,
		desc: topic.description?.replace(/<\/?[^>]*\/?[^>]*>/g, '') || topic.desc,
	};
}

/** Map /api/v2/patch-management_info into the same shape as xTopic_Repo for Action Explore. */
export function xPatchTopic_Info(criteria, patchInfo) {
	if (!criteria?.topicCode) return '';
	return {
		title: criteria.topicCode,
		severity: patchInfo?.severity,
		paramTitle: 'Version',
		desc: patchInfo?.description,
		category: patchInfo?.category,
		source: patchInfo?.source,
		rebootRequired: patchInfo?.rebootRequired,
		releaseDate: patchInfo?.releaseDate,
	};
}

export function xGeneric_Repo(actionDatum) {
	if (!actionDatum) return '';
	const repo = HA_genRemedies[actionDatum];
	return repo || {
		title: 'Unknown: ' + actionDatum + '. Please upgrade the software to the latest version.',
	};
}

// Fixed OS-patch actionDatum — UI-controlled label; never surface the kebab slug.
const OS_PATCH_ACTION_DATUM = 'download-and-install-os-patch';
const OS_PATCH_ACTION_TITLE = 'Download and Install OS Patch';

export const getRemedyDef = (actionType, actionDatum, topicCode) => {
	switch (actionType) {
		case 'remediate':
		case 'remediateAuto':
			if (actionDatum === 'default_registry_remediation')
				return xTopic_Repo(topicCode);
			if (actionDatum === OS_PATCH_ACTION_DATUM)
				return {title: OS_PATCH_ACTION_TITLE};
			return  HA_Remedies[actionDatum] ?? Comp_remedies[actionDatum];
		case 'generic':
			return xGeneric_Repo(actionDatum);
		default:
			return undefined;
	}
};

export const statsBarDefs = {
		muted: {h: 'Muted',
			l: 'Mute action rule(s) active for target device(s).',
			border: 'border-[#c9b316]',
			tx: 'text-[#c9b316]',
			bg: 'bg-[#c9b316]',
			contrastText: 'text-black',
			c: '#c9b316'},
		approvalPending: {h: 'Pending Approval',
			border: 'border-[#e3b4fd]',
			tx: 'text-[#e3b4fd]',
			bg: 'bg-[#e3b4fd]',
			contrastText: 'text-black',
			c: '#e3b4fd'},
		pending: {h: 'Pending',
			l: 'task(s) in progress / being applied on target device(s).',
			border: 'border-[#93b4fd]',
			tx: 'text-[#93b4fd]',
			bg: 'bg-[#93b4fd]',
			contrastText: 'text-black',
			c: '#93b4fd'},
		success: {h: 'Success',
			l: 'task(s) applied successfully on target device(s).',
			border: 'border-[#01EAC1]',
			tx: 'text-[#01EAC1]',
			bg: 'bg-[#01EAC1]',
			contrastText: 'text-white',
			c: '#01EAC1'},
		pendingReboot: {h: 'Pending reboot',
			l: 'patch installed; a device restart is required to complete it.',
			border: 'border-[#F5A623]',
			tx: 'text-[#F5A623]',
			bg: 'bg-[#F5A623]',
			contrastText: 'text-black',
			c: '#F5A623'},
		revertPendingReboot: {h: 'Revert pending reboot',
			l: 'revert applied; a device restart is required to complete it.',
			border: 'border-[#F5822A]',
			tx: 'text-[#F5822A]',
			bg: 'bg-[#F5822A]',
			contrastText: 'text-black',
			c: '#F5822A'},
		reverting: {h: 'Reverting',
			l: 'task(s) of revert-remediation in progress / being applied on target device(s).',
			border: 'border-[#666AFF]',
			tx: 'text-[#666AFF]',
			bg: 'bg-[#666AFF]',
			contrastText: 'text-white',
			c: '#666AFF'},
		reverted: {h: 'Reverted',
			l: 'task(s) reverted previous remediation on target device(s).',
			border: 'border-[#2C6BF9]',
			tx: 'text-[#2C6BF9]',
			bg: 'bg-[#2C6BF9]',
			contrastText: 'text-white',
			c: '#2C6BF9'},
		cancelled: {h: 'Cancelled',
			l: 'task(s) got cancelled before being applied on target device(s).',
			border: 'border-[#7F8593]',
			tx: 'text-[#7F8593]',
			bg: 'bg-[#7F8593]',
			contrastText: 'text-white',
			c: '#7F8593'},
		failed: {h: 'Failed',
			l: 'task(s) failed to apply.',
			border: 'border-[#E85893]',
			tx: 'text-[#E85893]',
			bg: 'bg-[#E85893]',
			contrastText: 'text-white',
			c: '#E85893'},
		revertCancelled: {h: 'Revert cancelled',
			l: 'revert task(s) got cancelled.',
			border: 'border-[#4C525E]',
			tx: 'text-[#4C525E]',
			bg: 'bg-[#4C525E]',
			contrastText: 'text-white',
			c: '#4C525E'},
		revertFailed: {h: 'Revert failed',
			l: 'task(s) failed to revert.',
			border: 'border-[#FF5B61]',
			tx: 'text-[#FF5B61]',
			bg: 'bg-[#FF5B61]',
			contrastText: 'text-white',
			c: '#FF5B61'},
	}, statsBarDefsArr = objToArrK(statsBarDefs);

export const muteStatsBarDefs = {
	...statsBarDefs,
	success: {h: 'Muted',
		l: 'muted successfully on target device(s).',
		border: 'border-[#c9b316]',
		tx: 'text-[#c9b316]',
		bg: 'bg-[#c9b316]',
		contrastText: 'text-black',
		c: '#c9b316'}
};

export const allowStatsBarDefs = {
	...muteStatsBarDefs,
	success: {...muteStatsBarDefs.success, h: 'Allowed', l: 'allowed successfully on target application(s).'}
};

export const taskStatuses = {
		...pickKeys(statsBarDefs, [
			'pending', 'success', 'pendingReboot', 'revertPendingReboot', 'reverting', 'reverted',
			'cancelled', 'failed', 'revertCancelled', 'revertFailed']),
	}, taskStatusesOpts = objToArrK(taskStatuses);

export const activeStateDefs = {
		active: {h: 'Active', border: 'border-prm-light', bg: 'bg-prm-light'},
		reverting: {noOpt: true, h: 'Active', border: 'border-prm-light', bg: 'bg-prm-light'},
		done: {h: 'Inactive', border: 'border-[#282090]', bg: 'bg-[#282090]'},
		approvalPending: {...statsBarDefs.approvalPending, h: 'Pending Approval', approval: true},
		approvalRejected: {...statsBarDefs.failed, h: 'Aprv. Rejected', approval: true},
		activating: {noOpt: true, h: 'Activating: might take a few minutes...', border: 'border-prm-light', bg: 'bg-prm-light'},
		deactivating: {noOpt: true, h: 'Deactivating: might take a few minutes...', border: 'border-[#282090]', bg: 'bg-[#282090]'},
		approvalTimedout: {noOpt: true, ...statsBarDefs.failed, h: 'Approval timed out', approval: true},
	}, activeStateDefsOpts = objToArrK(activeStateDefs);

export const operationLogDefs = {
	create: {h: 'Created', c: statsBarDefs.pending.bg},
	activate: {...activeStateDefs.activating, h: 'Restarted'},
	deactivate: {...activeStateDefs.deactivating, h: 'Stopped'},
	revert: {...activeStateDefs.reverting, h: 'Reverted'},
	update: {...statsBarDefs.success, h: 'Updated'},
	'revert-task': {...activeStateDefs.reverting, h: 'Reverted Task'},
	'remediation-success': {...statsBarDefs.success, h: 'Remediation Success'},
	'remediation-pending-reboot': {...statsBarDefs.pendingReboot, h: 'Pending reboot'},
	'remediation-failed': {...statsBarDefs.failed, h: 'Remediation Failed'},
	'revert-success': {...statsBarDefs.reverted, h: 'Revert Success'},
	'revert-pending-reboot': {...statsBarDefs.revertPendingReboot, h: 'Revert pending reboot'},
	'revert-failed': {...statsBarDefs.revertFailed, h: 'Revert Failed'},
	'revert-cancelled': {...statsBarDefs.cancelled, h: 'Revert Cancelled'},
	done: {...activeStateDefs.done, h: 'Finished'},
	approvalRejected: {...activeStateDefs.approvalRejected},
	approvalTimedout: {...activeStateDefs.approvalTimedout},
};

export const actionStatsFields = {
	latestActivity:{h: 'Last activity', f: v => dispDateTime(v)},
	user: {h: 'User'},
	remark: {h: 'Action Notes'}
};

export const actionSortDefs = {
		appliedTime: {h: 'Applied time'},
		initiatedTime: {h: 'Initiated time'},
	}, actionSortOpts = objToArrK(actionSortDefs);

export const actionDefs = {
		'remediate': {h: 'Remediate', xc: '#537dee', override: {[BenchmarkOrg.appControl]: {h: 'Uninstall'}, [BenchmarkOrg.osPatch]: {h: 'Patch'}, [BenchmarkOrg.appVuln]: {h: 'Patch'}, [BenchmarkOrg.osVuln]: {h: 'Patch'}}},
		'muteAlert': {h: 'Mute Alert', xc: '#93b4fd', override: {[BenchmarkOrg.appControl]: {h: 'Allow'}}},
		'revert': {h: 'Revert', xc: '#0079be'},
		'remediateAuto': {h: 'Auto Remediate', override: {[BenchmarkOrg.appControl]: {h: 'Auto Uninstall'}}},
		'generic': {h: 'Generic'},
		'patch': {h: 'Patch', xc: '#537dee'},
		'patchAuto': {h: 'Auto Remediation Patch', xc: '#537dee'},
	}, actionDefsArr = objToArrK(actionDefs);

// Types filter chips: the real action types minus Generic (which is filtered out of the Action Center list).
export const actionTypeFilterOpts = actionDefsArr.filter(opt => opt.k !== 'generic' && opt.k !== 'patchAuto');

export const getActionTypeTitle = (data) => getActionTypeTitleOverride(data.actionType, data.criteria.benchmarkOrg);

export const getActionTypeTitleOverride = (actionType, benchmarkOrg) => {
	const override = actionDefs[actionType]?.override?.[benchmarkOrg];
	return override?.h ? override.h : actionDefs[actionType]?.h;
};

export const actionEdits = {
	stop: {h: 'Stop', icon: 'delete'},
	revert: {h: 'Revert', icon: 'undo'},
	restart: {h: 'Restart', icon: 'loop2'},
};

export const taskRemStatusDefs = {
		'pending': {...statsBarDefs.pending},
		'assigned': {...statsBarDefs.reverting, h: 'Assigned'},
		'success': {...statsBarDefs.success},
		'pending-reboot': {...statsBarDefs.pendingReboot},   // per-task status is the hyphenated long form; list bucket / filter use "pendingReboot".
		'revert-pending-reboot': {...statsBarDefs.revertPendingReboot},   // per-task hyphenated; list bucket / filter is "revertPendingReboot".
		'failed': {...statsBarDefs.failed},
		'cancelled': {...statsBarDefs.cancelled},
	}, taskRemStatusDefsArr = objToArrK(taskRemStatusDefs);

export const taskRevertStatusDefs = {
		'pending-revert': {...statsBarDefs.pending},
		'revert-not-done-alert-found': {...statsBarDefs.reverting, h: 'Assigned'},
		'verifying-revert': {...statsBarDefs.reverted, altK: 'reverted'},
		'revert-pending-reboot': {...statsBarDefs.revertPendingReboot, altK: 'revertPendingReboot'},
		'failed-revert': {...statsBarDefs.revertFailed, h: 'Revert Failed'},
		'revert-cancelled': {...statsBarDefs.revertCancelled, h: 'Revert Cancelled'},
	}, taskRevertStatusDefsArr = objToArrK(taskRevertStatusDefs);

export const actionLogSortDefs = {
		'latestActivity': {h: 'Latest activity'},
    // "topicTitle": {h: "Attack Vector"},
		'activeTasks': {h: 'Active tasks'},
		'totalTasks': {h: 'Total tasks'}
	}, actionLogSortOpts = objToArrK(actionLogSortDefs);

export const partialActionDefs = {
		'groupId': {h: 'Device Group'},
		'device': {h: 'Device Name'},
		'deviceId': {h: 'Device Name'},
		'deviceGuid': {h: 'Device Name'},
		'computerOu': {h: 'Org. Unit'},
		'domain': {h: 'Domain'},
		'param': {h: 'Attack Vector Instance'},
		'paramExtra': {h: 'Attack Vector Instance'},
	}, partialActionFields = Object.keys(partialActionDefs);

export const disableActionMsg = (oSels, disabledActions, isViewOnly, disabledMsg) => {
	if (isViewOnly) return 'Action cannot be applied: user has only View permissions.';
	if (!oSels.numSelected()) return 'Please select at least one item.';
	if (disabledActions.length === oSels.numSelected()) return disabledMsg || 'Cannot perform operation on selected action.';
};

export const filterEditableRules = (selectedOperation, oSels) => {
	const excludedObj = {};
	const sels = oSels.getSelection();
	const rulesInfo = oSels.getSelItems().toObj((o, r) => o[r.ruleId] = r);
	const findDone = (id) => ['done', 'deactivating'].includes(rulesInfo[id]?.state);

	const disabledActions = [];
	const disabledIds = new Set();
	let disabledMsg;

	const assertAction = (operation, filterRuleInfo, filterRule, shouldGrayOutBtn = false) => {
		if (operation === selectedOperation && sels.some(id => filterRule(id))) {
			excludedObj[filterRuleInfo] = sels.filter(id => filterRule(id));
			if (shouldGrayOutBtn) {
				const newIds = sels.filter(id => filterRule(id) && !disabledIds.has(id));
				newIds.forEach(id => disabledIds.add(id));
				disabledActions.push(...newIds.map(id => rulesInfo[id]?.actionType));
				if (!disabledMsg) disabledMsg = filterRuleInfo;
			}
		}
	};
	const isActivating = (id) => rulesInfo[id]?.state === 'activating';
	assertAction('restart', 'Cannot perform operation on Mute actions', (id) => rulesInfo[id]?.actionType === 'muteAlert', true);
	assertAction('stop', 'Cannot Stop while tasks are still being assigned', isActivating, true);
	assertAction('restart', 'Cannot Restart while tasks are still being assigned', isActivating, true);
	assertAction('stop', 'Cannot perform operation on already inactive actions', (id) => findDone(id));
	assertAction('restart', 'Cannot perform operation on already active actions', (id) => !findDone(id) && !isActivating(id));
	assertAction('revert', 'Revert operation unavailable for this action', (id) => rulesInfo[id]?.canRevert === false, true);

	const filteredExcludedObj = Object.fromEntries(
		Object.entries(excludedObj).filter(([_, arr]) => arr.length > 0)
	);
	const inApplicable = Object.values(filteredExcludedObj).flat();

	return {excludedObj: filteredExcludedObj, disabledActions, disabledMsg, ids: sels.filter(id => !inApplicable.includes(id)), rulesInfo};
};

export const filterRevertibleTasks = (oSels) => {
	const excludedObj = {};
	const sels = oSels.getSelection(), tasksInfo = oSels.getSelItems().toObj((o, r) => o[r.taskId] = r);
	const isRevertable = (id) => tasksInfo[id]?.isRevertable;
	const isSuccessful = (id) => tasksInfo[id]?.revertTime || ['pending', 'success', 'pending-reboot'].includes(tasksInfo[id]?.status);

	const disabledIds = new Set();
	let disabledMsg;

	const assertTask = (excludedInfo, filterTask) => {
		const excludedIds = sels.filter(id => filterTask(id) && !disabledIds.has(id));
		if (!excludedIds.length) return;
		excludedObj[excludedInfo] = excludedIds;
		excludedIds.forEach(id => disabledIds.add(id));
		disabledMsg = disabledMsg? 'None of the selected tasks can be reverted.' : excludedInfo + '.';   // Mixed reasons can't claim a single one.
	};

	assertTask('Cannot perform Revert on non-successful remediation tasks', (id) => !isSuccessful(id));
	assertTask('Cannot perform operation on non-revertible tasks', (id) => !isRevertable(id));

	return {excludedObj, disabledMsg, ids: sels.filter(isRevertable), rulesInfo: tasksInfo};
};

export const disableTaskActionMsg = (actionType, oSels, isViewOnly) => {
	if (isViewOnly) return 'Action cannot be applied: user has only View permissions.';
	if (!oSels.numSelected()) return 'Please select at least one item.';
	if (actionType !== 'revert') return;

	const {ids, disabledMsg} = filterRevertibleTasks(oSels);
	if (!ids.length) return disabledMsg || 'Cannot perform Revert on the selected tasks.';
};

const AllRemedies = Object.values({...HA_Remedies, ...Comp_remedies});

export const getTopicRemedies = (topicCode, warn = false) => {
	const remedies = AllRemedies.filter(r =>
		Array.isArray(r.topics) ? r.topics.includes(topicCode) :  r.topic === topicCode);
	if (warn && !remedies.length) console.warn(`No remedies found for topicCode: ${topicCode}`);
	return remedies;
};

export const criteriaDefs = {
		device: {h: 'Device Name', f: (val) => val},
    // devices: {h: "Device(s)", f: v => v?.length && `${v.slice(0, 2).join(", ")}${v.length <= 2? "" : ` + ${(v.length - 2).toLocaleString()}`}`},
    // listGuids: {h: "Device(s)", f: (val) => val?.length},
		groupId: {h: 'Group', f: (val, groups) => groups?.find(g => g.groupId === val)?.groupName},
		domain: {h: 'Domain', f: (val) => val === undefined || val === null ? val : (val || '(no domain)')},
		label: {h: 'Label', f: (val) => val},
		param: {h: 'Instance', f: (val, _, crit) => isVuln(crit) ? undefined : val},
		notUsedInDays: {h: 'Last Used', f: (val) => notUsedInDaysOpts.find(opt => opt.k === val)?.h},
		os: {h: 'OS', f: (val) => val},
		ip: {h: 'IP', f: (val) => val},
		computerOu: {h: 'Org. Unit', f: (val) => val},
		osVersions: {h: 'OS Version', f: (val) => val?.join(', ')},
		policyName: {h: 'Custom CIS Policy', f: (val) => val},
		severities: {h: 'Severities', f: (val) => val?.join(', ')},
		flags: {h: 'Flags', f: (vals) => vals?.map(val => misconTopicFlags[val]?.h).join(', ')},
		benchmarkProfiles: {h: 'CIS Profiles', f: (val) => val?.map(benchmark => Benchmark_cisProfilesById[benchmark]?.title).undup().join(', ')},
		benchmarkProfile: {h: 'CIS Level', f: (val) => val && (Benchmark_cisProfilesById[val]?.title || benchmarkLevelOpts.find(level => level.k === val)?.h)},
		targetName: {h: 'Target', f: (val) => val},
		scanType: {h: 'Scan type', f: (val) => val && (val === 'discovery_enrichment' ? 'Discovery + Exposure' : 'Discovery only')},
	}, criteriaDefsArr = objToArrK(criteriaDefs);

export const filterCriteriaDefs = {
		...criteriaDefs,
		param: {h: 'Instance', f: (val) => val, addParams: ['isExactParam', 'paramExtra']}, // isExactParam does not exist in combiDefs.
		computerOu: {h: 'Org. Unit', f: (val) => val, addParams: ['isExactComputerOu']},
		os: {h: 'OS', f: (val) => val, addParams: ['isExactOs']},
		deviceGuid: {h: 'Device', f: (val, _, params) => val && (params.device ?? '(1 device)')},
		deviceId: {h: 'Device', f: (val, _, params) => val && (params.device ?? '(1 device)')},
	}, filterCriteriaDefsArr = objToArrK(filterCriteriaDefs);

export const taskInfo = {
		domain: {h: 'Domain', f: (val) => val === undefined || val === null ? val : (val || '(no domain)')},
		os: {h: 'OS', f: (val) => val},
		computerOu: {h: 'Org. Unit', f: (val) => val},
	}, taskInfoArr = objToArrK(taskInfo);

export const descActionCriteria = (crit, groups, defsArr = criteriaDefsArr) => [
	...defsArr.map(def => {
		const val = def.f(crit[def.k], groups, crit);
		return val && `${def.h}: ${val}`;
	}),
	isVuln(crit) && !crit.list?.length && crit.paramExtra &&
        `${crit.benchmarkOrg === BenchmarkOrg.osVuln ? 'Patch' : 'Application Version'}: ${crit.paramExtra}`,
	(crit.deviceGuid || crit.deviceId) && !crit.listGuids?.length && !crit.listIds?.length && '1 device',
	getListDesc(crit)
];

const isPatchMngmt = crit => [BenchmarkOrg.appVuln, BenchmarkOrg.osVuln, BenchmarkOrg.appControl].includes(crit.benchmarkOrg);
const isVuln = crit => [BenchmarkOrg.appVuln, BenchmarkOrg.osVuln].includes(crit?.benchmarkOrg);   // Vuln instance lives in paramExtra/listParamExtra (the version), not param.
// OS Vuln instances are patches; app vuln / app-control keep the longer "application version" fallback.
const patchMngmtInstanceLabel = crit => crit?.benchmarkOrg === BenchmarkOrg.osVuln ? 'patch' : 'application version';

export const getListDesc =  (crit, showInstances = true) =>
	crit.by && (crit.listGuids?.length || crit.listIds?.length || crit.list?.length ||                      // not SelectAll - devices or params are chosen?
        !(crit.by === 'alerts' ? isPatchMngmt(crit) ? crit.product : crit.param : (crit.device || crit.deviceGuid || crit.deviceId))) &&        // if SelectAll and no filter is applied for param or device - don't show "Any Instance / Device"
    getListDescByCrit(crit, isPatchMngmt(crit) ? patchMngmtInstanceLabel(crit) : xTopic_Repo(crit.topicCode)?.paramTitle, showInstances)?.k;

export function getListDescByCrit({
	by, isListExclude, list, listParamExtra, listGuids, listIds, topicCode, ...restCrit
}, paramTitle, showInstances = true) {
	const nObjs = (list?.length ?? 0) + (listGuids?.length ?? 0) + (listIds?.length ?? 0);
	const isAlerts = by === 'alerts';
	const isApp = by === 'topicCode';
	const type = isAlerts ? 'instance' : isApp ? 'application' : 'device';

	const prefix = !nObjs ? isListExclude ? 'Any ' : '' : isListExclude ? 'All except ' : '';
	const count = nObjs ? nObjs.toLocaleString() + ' ' : '';
	const noun = type.plural(nObjs || 2);   // Plural for "All"/"Any" (nObjs=0), otherwise by count.
	const suffix = isAlerts ? (paramTitle ? ` (${paramTitle})` : topicCode
		? isPatchMngmt(restCrit) ? ` (${patchMngmtInstanceLabel(restCrit)})` : ` of ${xTopic_Repo(topicCode)?.title}`
		: '') : '';
	const previewSrc = isVuln(restCrit) && listParamExtra?.some(Boolean) ? listParamExtra : list;   // Vuln instance is the paramExtra (version), not the internal param id.
	const preview = previewSrc?.length && showInstances ? `: ${previewSrc.slice(0, 2).join(', ')}${previewSrc.length > 2 ? ', ...' : ''}` : '';

	return {h: 'By', k: `${prefix}${count}${noun}${suffix}${preview}`};
}

export const actionOptsDefs = [...Object.entries(HA_Remedies), ...Object.entries(Comp_remedies), ...Object.entries(HA_genRemedies)]
	.toObj((o, [k, v]) => o[k] = ({...v, h: v.title, k}));

export const metricOptsDefs = [...Object.entries(HA_topics), ...Object.entries(Benchmark_rules)]
	.toObj((o, [k, v]) => o[k] = ({...v, h: v.title, k}));

const topicCodeTitleOrgs = [BenchmarkOrg.appVuln, BenchmarkOrg.osVuln, BenchmarkOrg.osPatch];

export const getActionTitle = (data, addColon = true) => {
	const repo = xTopic_Repo(data.criteria?.topicCode);
	const remedyTitle = data.actionDatum === OS_PATCH_ACTION_DATUM && data.criteria?.topicCode
		? undefined
		: getRemedyDef(data.actionType, data.actionDatum)?.title;
	const title = remedyTitle
        || data.criteria?.ruleName
        || (!repo.unrecognized && repo?.title)
        || (BenchmarkOrg.appControl === data.criteria.benchmarkOrg && data.criteria?.topicCode)
        || (topicCodeTitleOrgs.includes(data.criteria.benchmarkOrg) && data.criteria?.topicCode + (data.criteria.product ? ' - ' + data.criteria.product : ''));
	return title ? addColon ? `: ${title}` : title : '';
};

export const filterModulesDefs = {         //  Filter works by sending modules to exclude.
		'all': {h: 'All sources', exclude: []},
		'miscon': {h: 'Misconfig.', exclude: ['benchmark', 'app_control', 'app_vuln_assessment', 'patch_vuln_assessment', 'patch_management', 'customcis', 'network_scanner']},
		'generic': {h: 'Misc. / Generic', exclude: ['network_scanner']},
		'customcis': {h: 'Custom CIS', exclude: ['miscon', 'app_control', 'app_vuln_assessment', 'patch_vuln_assessment', 'patch_management', 'benchmark', 'network_scanner'], perms: 'customcis'},
		'benchmark': {h: 'Compliance', exclude: ['miscon', 'app_control', 'app_vuln_assessment', 'patch_vuln_assessment', 'patch_management', 'customcis', 'network_scanner'], perms: 'benchmark'},
		'vuln_assessment': {h: 'Vuln. Assessment', exclude: ['miscon', 'app_control', 'benchmark', 'patch_management', 'customcis', 'network_scanner'], perms: 'vuln_assessment'},
		'patch_management': {h: 'Patches', exclude: ['miscon', 'app_control', 'benchmark', 'app_vuln_assessment', 'patch_vuln_assessment', 'customcis', 'network_scanner'], perms: validatePatchModuleLicense},
		'app_control': {h: 'App Control', exclude: ['miscon', 'benchmark', 'app_vuln_assessment', 'patch_vuln_assessment', 'patch_management', 'customcis', 'network_scanner'], perms: 'app_control'},
	}, filterModuleOpts = objToArrK(filterModulesDefs);

export const actionTypes = {
	remediate: {h: 'Remediate'},
	remediateAuto: {h: 'Auto Remediate'},
	generic: {h: 'Generic Action'},
	muteAlert: {h: 'Mute Alert'},
	clientUpdate: {h: 'Sensor Update'},
};
